export const EXAMPLE_QUESTION_IDS = [
    'assistant.examples.escalatorRepairCost',
    'assistant.examples.totalRepairSpend2024',
    'assistant.examples.inspectionPriceRange',
    'assistant.examples.avgUnitPriceTopProviders',
    'assistant.examples.governorRopeShortened',
    'assistant.examples.topExpensiveElevators',
    'assistant.examples.topRecurringServices',
    'assistant.examples.topElevatorsBySpend2024',
    'assistant.examples.topElevatorManufacturers',
];
